/* eslint-disable react/prop-types */
import React, { useContext, useState, useEffect } from 'react';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import Avatar from 'venuescanner-js/react/components/Inbox/components/Objects/Avatar';
import cl from 'classnames';
import userTypes from 'venuescanner-js/constants/user_type';
import controllers from 'venuescanner-js/services/controllers';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import Box from '@mui/material/Box';
import {
  possibleRedactMessage,
  possibleRedactUrls,
} from 'venuescanner-js/utils/redaction';

const RedactedMessage = ({ redactItem }) => {
  const [style, setStyle] = useState({});
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    // console.log({ redactItem })
    if (redactItem) {
      setMessage(redactItem ? redactItem.dataset.bubble : '');
      const rect = redactItem.getBoundingClientRect();
      const onLeft = rect.left + rect.width / 2 < window.innerWidth / 2;
      // console.log({ onLeft, center: (rect.left + (rect.width / 2)), windowCenter: window.innerWidth / 2 })
      const width = 200;
      const left = onLeft ? `${rect.left}px` : 'auto';
      const right = onLeft ? 'auto' : `${window.innerWidth - rect.right}px`;
      const toSet = {
        width: `${width}px`,
        top: `${rect.top}px`,
        left,
        right,
      };
      // console.log(toSet)
      setStyle(toSet);
      setShow(true);
    } else {
      setShow(false);
    }
  }, [redactItem]);
  return (
    <div style={style} className={cl('redacted-message', { on: show })}>
      {message}
    </div>
  );
};
const Message = props => {
  // eslint-disable-next-line react/prop-types
  const { thread, message } = props;
  const { activeUser } = useContext(ViewContext);
  // sentByUs may be different from sentByMe, if I am a host, it may have been sent by a colleague
  const concierge = message.from_type === userTypes.concierge;
  const fromType =
    message.from_type === userTypes.host
      ? userTypes.host
      : [userTypes.organiser, userTypes.concierge].includes(message.from_type)
      ? userTypes.organiser
      : message.from_type;
  const fromId = message.from._id || message.from;

  const [sentByUs] = useState(fromType === thread.viewerRole);
  const [sentByMe] = useState(fromId === activeUser._subjects._value._id);
  const [showDataFor] = useState(`_${fromType}`);
  const [redactItem, setRedactItem] = useState();

  const attachTrackingToLinks = (el, thread) => {
    if (el) {
      el.querySelectorAll('a').forEach(link => {
        if (!link._linkwatching) {
          link.addEventListener('click', e => {
            // e.preventDefault()
            let url = e.target.href;
            let variant = 'url';
            if (url.match(/^mailto:/)) {
              variant = 'mailto';
              url = url.replace(/^mailto:/, '');
            } else if (url.match(/^tel:/)) {
              variant = 'tel';
              url = url.replace(/^tel:/, '');
            }
            controllers.thread.clickedLink.post({
              threadId: thread._id,
              viewerRole: thread.viewerRole,
              variant,
              url,
            });
            return false;
          });
          link.addEventListener('mouseenter', e => {
            setRedactItem(e.target);
          });
          link.addEventListener('mouseleave', () => {
            setRedactItem(null);
          });
          link._linkwatching = true;
        }
      });
    }
  };
  // anotherHost indicates that someone from the Venue replied, but they are not the associated host
  const anotherHost =
    fromType === userTypes.host && message.from !== thread.host;
  const firstName =
    concierge || anotherHost
      ? message.from_name
      : thread[showDataFor]?.name || '';
  const lastName =
    concierge || anotherHost ? '' : thread[showDataFor]?.lastName || '';
  const imageUrl =
    concierge || anotherHost
      ? null
      : thread[showDataFor]?.profile_photo
      ? thread[showDataFor]?.profile_photo !== '[object Object]'
        ? `https://cdn.venuescanner.com/${thread[showDataFor].profile_photo}`
        : null
      : null;

  const hide = false; // [type.PAYMENT, type.PAYMENT_REQUEST].includes(message.type)

  const messageContent = possibleRedactUrls(
    thread._venue,
    thread.viewerRole,
    possibleRedactMessage(thread._venue, thread.viewerRole, message.msg),
  );

  return hide ? null : (
    <div
      className={`message ${sentByUs ? 'message__sent' : 'message__received'}`}
      data-message={message._id}>
      <RedactedMessage redactItem={redactItem} />
      {messageContent !== ' ' && (
        <div
          className='message__content'
          dangerouslySetInnerHTML={{ __html: messageContent }}
          ref={el => {
            attachTrackingToLinks(el, thread);
          }}
        />
      )}
      {!!message?.attachments?.length && (
        <div className='message__attachments'>
          {message.attachments.map(attachment => {
            return (
              <a
                key={attachment._id}
                className='message__attachment'
                href={attachment.attachmentURL || attachment.attachmentPath}
                target='_blank'
                rel='noopener noreferrer'>
                <FilePresentOutlinedIcon
                  sx={{ strokeWidth: 1 }}
                  fontSize='large'
                  htmlColor={sentByUs ? '#fff' : '#000'}
                />
                {attachment.attachmentName && (
                  <Box
                    component='span'
                    mt={1}
                    sx={{
                      color: sentByUs ? '#fff' : '#000',
                      fontSize: '12px',
                    }}>
                    #
                    {attachment.attachmentName.replace(
                      /([^\\]{5})[^\\]+?([^\\]{0})$/,
                      '$1...$2',
                    )}
                  </Box>
                )}
              </a>
            );
          })}
        </div>
      )}
      {!sentByMe && (
        <Avatar
          concierge={concierge}
          names={[firstName, lastName]}
          imageUrl={imageUrl}
          size={'xsmall'}
          isCircle={true}
        />
      )}
    </div>
  );
};

export default Message;
